import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Professionals from "@/components/Professionals";
import ContactCTA from "@/components/ContactCTA";
import Location from "@/components/Location";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-ink antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Professionals />
        <ContactCTA />
        <Location />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
